import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import newlogo from '../assets/headlogo.png'
import menu from '../assets/hamburger.png'
import 'react-accessible-accordion/dist/fancy-example.css';
import './header.css'
import drop from '../assets/drop.png'
import search from '../assets/h-search.png'
import createHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import Axios from 'axios';
import drops from '../assets/drops.png'
import { BASE } from '../api/api';
import OutsideClickHandler from 'react-outside-click-handler';


const history = createHistory()
ReactGA.initialize('UA-139161970-1');
history.listen((location, action) => {
  ReactGA.pageview(location.pathname);
  console.log(location.pathname)
});

class HeaderSmall extends Component {
  constructor(props) {
    super(props);
    console.log(props, "nextprops")
    this.state = {
      menu: false,
      langeng: props.langset ? true : false,
      aboutcis: false,
      databank: false,
      institution: false,
      newsevents: false,
      more: false,
      submenu: 0,
      show_menu: false,
      headersicky: false,
      absolute: false,
      keyword: '',
      searchfilter: '',
      redirect: false,
      search: '',
      menus: []
    }

    this.handleScroll = this.handleScroll.bind(this);

  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      langeng: nextProps.langset ? true : false,

    })
  }

  componentWillMount() {
    this.setState({
      absolute: false,
      headersicky: false
    })
  }
  componentWillUnmount() {
    this.setState({
      absolute: false,
      headersicky: false
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    Axios.get(BASE + 'jsonapi/node/page?filter[field_front_end_sub_menu]=1&sort=field_sort')
      .then(resp => {
        console.log('menus', resp.data.data)
        this.setState({
          menus: resp.data.data
        })
      })
  }

  handleScroll(event) {
    var w = window.innerWidth;
    var h = document.getElementById("root").offsetHeight;
    // console.log(window.pageYOffset, h)

    if (h < 740) {
      if (window.pageYOffset > 65) {
        // alert('fixed')
        this.setState({
          headersicky: true,
          absolute: true
        })
      }
      if (window.pageYOffset === 0)
        this.setState({
          absolute: false,
          headersicky: false
        })
    }
    else {
      this.setState({
        absolute: false
      })
      if (window.pageYOffset > 65) {
        // alert('fixed')
        this.setState({
          absolute: true,
          headersicky: true,

        })
      }
      else {
        this.setState({
          headersicky: false
        })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.setState({
      headersicky: false,
    })
  }
  componentWillMount() {
    let dat = localStorage.getItem('token');
    if (dat && dat != null) {
      this.setState({
        show_menu: true
      })
    }
  }
  componentWillReceiveProps() {
    let dat = localStorage.getItem('token');
    if (dat && dat != null) {
      this.setState({
        show_menu: true
      })
    }
  }
  langset(id) {
    if (this.props.langSelected)
      this.props.langSelected(id);
    if (id === 'eng') {
      this.setState({
        langeng: true

      })
      localStorage.removeItem('lang');

    }
    else {
      this.setState({
        langeng: false
      })
      localStorage.setItem("lang", JSON.stringify(true));

    }
  }

  checkLogin() {
    let lgn = localStorage.getItem('token');
    if (!lgn && lgn == null) {
      window.location.href = "/login"
    }
  }

  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    this.setState({ show_menu: false })
    window.location.href = '/'
  }

  gloss_search(e) {
    if (this.props.headerActive) {
      this.props.headerActive(e)
    }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  _handleKeyPress(e) {

    if (e.key === 'Enter') {
      this.search()
    }
  }
  search() {
    if (this.state.keyword.length < 3) {
      // alert("Enter atleast 3 characters")
      this.fillalert("Enter atleast 3 characters")

    }
    else
      window.location.href = '/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20')
    history.push('/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20'))
  }
  fillalert(msg) {
    this.setState({
      filltext: msg,
      fillalert: true
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null
        })
      }
        .bind(this),
      3000
    );
  }


  render() {

    return (

      <div style={{ position: "fixed", display: this.state.headersicky ? "" : "none" }} className="headernew headerbkp">
        <div className="container">
          {/* <ul className={!this.state.langeng ?"headertopara":this.state.headersicky?"headertopsticky":"headertop"}>
                <li style={{display:this.state.show_menu === false ? "":'none'}}><Link to="/login">{!this.state.langeng ? 'تسجيل الدخول' : 'Login'}</Link></li>
                <li style={{display:this.state.show_menu === true ? "":'none'}}><a onClick={()=>this.signout()}>{!this.state.langeng ? 'خروج' : 'SIGN OUT'}</a></li>

                <li style={{display:this.state.langeng === false ? "":'none'}} onClick={() => this.langset('eng')} >ENGLISH</li>
                <li style={{display:this.state.langeng === false ? "none":''}} onClick={() => this.langset('ara')} >العربية</li>
            </ul> */}
          <div className={this.state.headersicky ? "headerbottom headerbottomsticky" : "headerbottom"}>
            <Link to='/' className={this.state.headersicky ? "newlogosticky" : "newlogo"}>
              <img src={newlogo} alt='logo' />
            </Link>
            <ul className="newmenu">
              <li onMouseEnter={() => this.setState({ databank: true })} onMouseLeave={() => this.setState({ databank: false })} className='mainlinkdiv' className="mainlink">
                <div className='mainlinkdiv' >{!this.state.langeng ? 'بنك المعلومات' : 'Specialized Projects'} {this.state.databank ? <img src={drop} /> : ''}{this.state.databank ? <div className='up-arrow'></div> : ''}</div>
                <ul style={{ display: this.state.databank ? '' : 'none' }} className="hovers">
                  {/* <Link onMouseEnter={() => this.setState({ sidehovershow: true })} to='/economics'>{!this.state.langeng ? 'بنك المعلومات' : 'Islamic Economics & Finance'}</Link> */}
                  <div className='sidehovers' onMouseLeave={() => this.setState({ sidehovershow: false })} style={{ display: this.state.sidehovershow ? '' : 'none' }}>
                    {this.state.sidehovershow ? <div className='left-arrow'></div> : ''}
                    <Link to="/biographies">{!this.state.langeng ? 'السير الذاتية' : 'Biographies'}</Link>
                    <Link to="/glossary">{!this.state.langeng ? 'مسرد المصطلحات' : 'Glossary'}</Link>
                    {/* <Link to="/banking_regulation">{!this.state.langeng ? 'القوانين المصرفية' : 'Banking Regulations'}</Link> */}
                    <Link to="/periodicals/English/0">{!this.state.langeng ? 'الدوريات' : 'Islamic Finance Periodicals'}</Link>
                    <Link to='/financial_institution' >{!this.state.langeng ? 'المؤسسات المالية في قطر' : 'Financial Institutions In Qatar'}</Link>
                    <Link to='/academic_institution/page/0'>{!this.state.langeng ? 'المؤسسات الأكاديمية' : 'Academic Institutions'}</Link>
                  </div>
                  {this.state.menus.length ? this.state.menus.map((data) => {
                    return (
                      <Link onMouseEnter={() => this.setState({ sidehovershow: data.attributes.title === 'Islamic Economics & Finance' ? true : false })} to={`/specialised/${data.attributes.title}`}>{data.attributes.title}</Link>
                    )
                  }) : ''}
                  {/* <Link onMouseEnter={() => this.setState({ sidehovershow: false })} to='/bioethics'>{'Islamic Bioethics Project'}</Link>
                  <Link onMouseEnter={() => this.setState({ sidehovershow: false })} to='/convenants'>{'Covenants of the Prophet Muhammad'}</Link>
                  <Link onMouseEnter={() => this.setState({ sidehovershow: false })} to='/sira'>{'The Digital Sira Initiative'}</Link> */}

                  {/* <li className=" leaf" style={{ display: this.state.show_menu === true ? '' : 'none' }}><Link to="/submit_your_work">{!this.state.langeng ? 'أرسل عملك' : 'Submit Your Work'}</Link> */}
                </ul>
              </li>
              <li onMouseEnter={() => this.setState({ cis_research: true })} onMouseLeave={() => this.setState({ cis_research: false })} className="mainlink">
                <div className='mainlinkdiv' >{!this.state.langeng ? 'أبحاث' : 'Research'} {this.state.cis_research ? <img src={drop} /> : ''}{this.state.cis_research ? <div className='up-arrow'></div> : ''}</div>
                <ul style={{ display: this.state.cis_research ? '' : 'none' }} className="hovermenu-2 hovermenu-3">
                  <Link to='/report'>{!this.state.langeng ? 'استراتيجية البحث' : 'Research Division'}</Link>
                  <Link to='/research/cluster'>{!this.state.langeng ? 'مجموعات البحوث' : 'Research Clusters'}</Link>
                  <Link to='/ongoing'>{!this.state.langeng ? 'كتب' : 'Ongoing Research'}</Link>
                  <Link to="/research/faculty">{!this.state.langeng ? 'أعضاء هيئة التدريس' : 'CIS Faculty'}</Link>
                  <Link to='/theses'>{!this.state.langeng ? 'المؤسسات الأكاديمية' : 'CIS Student Theses'}</Link>
                  {/* <li className="leaf"><a href='https://www.hbku.edu.qa/en/cis/center/cief' target="_blank">{!this.state.langeng ? 'CIEF' : 'CIEF'}</a></li>
                            <li className="leaf"><a href='https://www.hbku.edu.qa/en/cis/center/cief' target="_blank">{!this.state.langeng ? 'CILE' : 'CILE'}</a></li>
                            <li className="leaf"><a href='https://www.hbku.edu.qa/en/cis/center/cief' target="_blank">{!this.state.langeng ? 'CMCC' : 'CMCC'}</a></li>
                            <li className="leaf"><a href='https://www.hbku.edu.qa/en/cis/center/cief' target="_blank">{!this.state.langeng ? 'QCIMR' : 'QCIMR'}</a></li>
                        */}
                </ul>
              </li>

              <li onMouseEnter={() => this.setState({ newsevents: true })} onMouseLeave={() => this.setState({ newsevents: false })} className='mainlinkdiv' className="mainlink">
                <Link to="/events/upcoming" className='mainlinkdiv' >{!this.state.langeng ? 'أخبار وأحداث' : 'Events'}</Link>
                {/* <ul style={{ display: this.state.newsevents ? '' : 'none' }} className="hovermenu">
                            <li className="leaf"><Link to="/news">{!this.state.langeng ? 'أخبار' : 'NEWS'}</Link></li>
                            <li className="leaf"><Link to="/events">{!this.state.langeng ? 'أحداث' : 'EVENTS'}</Link></li>
                      </ul> */}
              </li>
            </ul>
            <div className='headsearch-bar' style={{ display: window.location.pathname === '/' ? 'none' : '' }}>
              <input placeholder='Search' className='head-search' name="keyword" value={this.state.keyword} minLength="3" maxLength="50" onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} />
              <div className='search-bar'>
                <img onClick={() => this.search()} src={search} />
              </div>
            </div>
            {/* MOBILEMENU */}
            <div style={{ display: this.state.menu ? '' : 'none' }} onClick={() => this.setState({ menu: !this.state.menu })} className='bgblack'></div>

            <ul style={{ display: this.state.menu ? '' : 'none' }} className="side-nav listrea" id="mobile-demo">
              <ul className='menu'>
                {/* <li onClick={()=>this.setState({submenu:5})}  className="leaf"><Link to=''>English/عربى</Link></li>
                        <ul style={{display:this.state.submenu===5?'':'none'}} className='submenu'>
                              <li onClick={() => this.langset('eng')} className="leaf"><Link to="">English</Link></li>
                              <li onClick={() => this.langset('ara')} className="leaf"><Link to="">عربى</Link></li>
                              </ul> */}
                <div className="mob_lang_btn">
                  <div className='langbut' style={{ paddingBottom: 5, float: 'none' }}>
                    <div onClick={() => this.langset('eng')} style={{ color: this.state.langeng ? 'white' : '#165E84', backgroundColor: this.state.langeng ? '#165E84' : 'white' }}>English</div>
                    <div onClick={() => this.langset('ara')} style={{ color: !this.state.langeng ? 'white' : '#165E84', backgroundColor: !this.state.langeng ? '#165E84' : 'white' }}>عربى</div>
                  </div>
                  <div className="divider_line"></div>
                  <div className="loginmob">
                    <a style={{ display: this.state.show_menu === true ? "" : 'none' }} onClick={() => this.signout()}>{!this.state.langeng ? 'خروج' : 'SIGN OUT'}</a>

                    <Link style={{ display: this.state.show_menu === true ? "none" : '' }} to="/login">{!this.state.langeng ? 'تسجيل الدخول' : 'Login'}</Link>
                  </div>
                </div>
                {/* <li onClick={() => this.setState({ submenu: 1 })} className="leaf"><a>{!this.state.langeng ? 'عن الكلية' : 'About'}</a></li>
                  <ul style={{ display: this.state.submenu === 1 ? '' : 'none' }} className='submenu'>
                    <li className="leaf"><Link to="/about_cis">{!this.state.langeng ? 'عن الكلية' : 'About CIS'}</Link></li>
                    <li className="leaf"><Link to="/faculty">{!this.state.langeng ? 'أعضاء هيئة التدريس' : 'CIS Faculty'}</Link></li>
                  </ul> */}

                <li onClick={() => this.setState({ submenu: 2 })} className="leaf"><a>{!this.state.langeng ? 'بحاث الكلية' : 'Research'}</a></li>
                <ul style={{ display: this.state.submenu === 2 ? '' : 'none' }} className='submenu'>
                  <li className="leaf"><Link to="/research/division">{!this.state.langeng ? 'قسم البحوث' : 'Research Division'}</Link></li>
                  <li className="leaf"><Link to="/research/cluster">{!this.state.langeng ? 'مجموعات البحوث' : 'Research Clusters'}</Link></li>
                  <li className="last leaf"><Link to='/cis_publication'>{!this.state.langeng ? 'كتب' : 'CIS Publications'}</Link></li>
                  <li className="leaf"><Link to="/research/faculty">{!this.state.langeng ? 'أعضاء هيئة التدريس' : 'CIS Faculty'}</Link></li>
                  <li className="leaf"><Link to='/theses'>{!this.state.langeng ? 'المؤسسات الأكاديمية' : 'CIS STUDENT THESES'}</Link></li>

                </ul>

                <li onClick={() => this.setState({ submenu: 3 })} className="leaf"><a>{!this.state.langeng ? 'بنك المعلومات' : 'DATABANK'}</a></li>
                <ul className='submenu' style={{ display: this.state.submenu === 3 ? '' : 'none' }}>
                  <li className="leaf"><Link to="/biographies">{!this.state.langeng ? 'السير الذاتية' : 'Biographies'}</Link></li>
                  <li className="leaf"><Link to="/glossary">{!this.state.langeng ? 'مسرد المصطلحات' : 'Glossary'}</Link></li>
                  <li className="leaf"><Link to="/periodicals/English/0">{!this.state.langeng ? 'الدوريات' : 'Islamic Finance Periodicals'}</Link></li>
                  <li className="leaf"><Link to='/financial_institution' >{!this.state.langeng ? 'المؤسسات المالية في قطر' : 'Financial Institutions in Qatar'}</Link></li>
                  <li className="leaf"><Link to='/academic_institution/page/0' >{!this.state.langeng ? 'المؤسسات الأكاديمية' : 'Academic Institutions'}</Link></li>
                </ul>
                <li onClick={() => this.setState({ submenu: 4 })} className="leaf"><a>{!this.state.langeng ? 'أخبار وأحداث' : 'NEWS & EVENTS'}</a></li>
                <ul style={{ display: this.state.submenu === 4 ? '' : 'none' }} className='submenu'>
                  <li className="leaf"><Link to="/news">{!this.state.langeng ? 'أخبار' : 'News'}</Link></li>
                  <li className="leaf"><Link to="/events/upcoming">{!this.state.langeng ? 'أحداث' : 'Events'}</Link></li>

                </ul>
                <Link className='login-btn' style={{ display: this.state.show_menu === false ? "" : 'none' }} to="/login">{!this.state.langeng ? 'تسجيل الدخول' : 'LOGIN'}</Link>
                <li className='my-profile pointer' onClick={() => this.setState({ showprofile: true })} style={{ display: this.state.show_menu === true ? "" : 'none' }}>
                  <div>{!this.state.langeng ? 'ملفي' : 'MY PROFILE'} <span className='down-arrow'><img src={drops} /></span></div>
                </li>
                {this.state.showprofile ? <div className='up-arrows'></div> : ""}
                {this.state.showprofile ?
                  <OutsideClickHandler
                    onOutsideClick={() => this.setState({ showprofile: false })}>

                    <div className='profile-options'>
                      <Link className='pointer option' to='/profile'> Profile Overview</Link>
                      <Link className='pointer option' to='/submit_your_work/select'>Submit Your Work</Link>
                      <div className='pointer option' onClick={() => this.setState({ invite: true })}>Invite co-author</div>
                      <div className='pointer option'>Notifications</div>
                      <Link className='pointer option' to='/contact-us'>Contact I-BIR</Link>
                      <Link className='pointer option' to='/password'>Change/Reset Password</Link>
                      <div className='login-btn pointer option'><div onClick={() => this.signout()}>{!this.state.langeng ? 'خروج' : 'Log Out'}</div></div>
                    </div>
                  </OutsideClickHandler>
                  : ""}
              </ul>
            </ul>
            <div onClick={() => this.setState({ menu: !this.state.menu })} className="mobilemenu">
              <img src={menu} alt="mobilememnu" />
            </div>
          </div>

        </div>

      </div>

    )


  }

}

export default HeaderSmall;